import { focusCache, config } from '##/services/store/store';
import { PageNavigation } from '##/utils/PageNavigation';
import {
  TealiumErrorCode,
  TealiumErrorContext,
} from '##/services/analytics/Tealium/TealiumErrorTypes';
import { sendApiRequest } from '##/services/tenApi/apirequest';
import { sendErrorToTealium } from '../Error';

const getEndpointString = (endpoint = 'shows', id?: string): string =>
  `${config.$get()?.api.apiBaseUrl}/api/v1/${endpoint}/${id}`;

export const deepLinkShow = async ({
  seriesCrid,
  episodeCrid,
}: Record<string, string | undefined>): Promise<void> => {
  const endpointFromDeeplink = getEndpointString(
    'videos',
    `${seriesCrid}E${episodeCrid}`,
  );
  try {
    const { showId, season, id } = await sendApiRequest(endpointFromDeeplink);

    focusCache.tvShowDetails.$set({
      seasonTitle: season,
      isExtra: false,
      epId: id,
    });

    PageNavigation.replaceRoute('/show', getEndpointString('shows', showId));
  } catch (err) {
    PageNavigation.replaceRoute('/');
    sendErrorToTealium({
      errorCode: TealiumErrorCode.DLShow,
      errorContext: TealiumErrorContext.DEEPLINK,
      errorDetail: `Invalid or missing show deeplink parameters, got show episode endpoint ${endpointFromDeeplink}`,
      errorSource: '/deeplink-show',
      errorMessage: '',
    });
  }
};
